import { useSelector } from 'react-redux';

import { CREATE_EDIT_DELETE_CUSTOM_TAGS, VIEW_ASSIGN_CUSTOM_TAGS } from 'constants/ProjectConstants';

const selector = (state) => state.employeeGoalsAccessPrivileges;

export const useCustomTagPermissions = () => {
  const accessPrivilegesList = useSelector(selector);

  const hasCreateEditViewDeleteAssignCustomTags = accessPrivilegesList.includes(CREATE_EDIT_DELETE_CUSTOM_TAGS);

  const hasViewAssignCustomTags = accessPrivilegesList.includes(VIEW_ASSIGN_CUSTOM_TAGS);

  const canCreateEditViewDeleteAssignCustomTags = hasCreateEditViewDeleteAssignCustomTags;
  const canViewAssignCustomTags = hasViewAssignCustomTags || canCreateEditViewDeleteAssignCustomTags;

  return {
    canCreateEditViewDeleteAssignCustomTags,
    canViewAssignCustomTags,
  };
};
